export default "__VITE_PUBLIC_ASSET__391a66de__"